import { render, staticRenderFns } from "./doctorSettings.vue?vue&type=template&id=a35d2e0e&scoped=true"
import script from "./doctorSettings.vue?vue&type=script&lang=js"
export * from "./doctorSettings.vue?vue&type=script&lang=js"
import style0 from "./doctorSettings.vue?vue&type=style&index=0&id=a35d2e0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35d2e0e",
  null
  
)

export default component.exports